// extracted by mini-css-extract-plugin
export var borderRadius = "_6m-4";
export var large = "_6m-3";
export var logoContainer = "_6m-0";
export var nameLogo = "_6m-2";
export var small = "_6m-1";